import { Question } from "./questions";
import { Classification } from "@/types/classification";

export const getActivitySettingsQueryKey = () => ["activitySettings"] as const;

export interface ActivitySettings {
    max_open_unique_activities_per_teacher: number;
    reflection_seconds_per_question: number;
    reflection_question_precentage: number;
    default_activity_completion_precentage: number;
    default_city_activities_target: number;
    reflection_questions: Question[];
    feedback_questions: Question[];
    feedback_seconds?: number;
    max_class_number: number;
    enabled_classes: Classification[];
    welcome_image: File | string | null;
}
